module.exports = __webpack_public_path__ + "img/stock0.e8cef1f6.png";